<template>
    <BaseSection v-if="image && image.length">
        <BaseLightBox
            :image="image"
            :allow-image-enlargement="allowImageEnlargement"
        >
            <template #image>
                <BaseConditionalLink
                    :internal-link="internalLink"
                    :external-link="externalLink"
                >
                    <BaseFigure
                        :src="image[0].intermediateUrl"
                        responsive
                        :srcset="getSrcSet(image[0], 'responsive')"
                        width="844"
                        sizes="(max-width: 768px) 100vw, (min-width: 769px) 880px, 100vw"
                        :alt="image[0].alt || ''"
                    >
                        <template #caption>{{ caption }}</template>
                    </BaseFigure>
                </BaseConditionalLink>
            </template>
        </BaseLightBox>
    </BaseSection>
</template>

<script setup>
import useSrcSets from '~/utils/srcset';

const { getSrcSet } = useSrcSets();

defineProps({
    caption: {
        type: String,
        default: null,
    },
    image: {
        type: Array,
        required: true,
    },
    allowImageEnlargement: {
        type: Boolean,
        default: false,
    },
    allowImageLink: {
        type: Boolean,
        default: false,
    },
    internalLink: {
        type: [String, Object],
        default: null,
    },
    externalLink: {
        type: String,
        default: null,
    },
});
</script>
